import React from 'react';

// Generated from the LegalApp design canvas.
export default function SpotAccused({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-spot-iso" viewBox="-107.0 -58.0 238.2 194.0" role="img" aria-label="Illustration: a notice of appearance and the accused's recorded statement" style={style}>
    <polygon points="121.2,70.0 24.2,126.0 24.2,118.0 121.2,62.0" fill="#C2D4F6" />
    <polygon points="-97.0,56.0 24.2,126.0 24.2,118.0 -97.0,48.0" fill="#E1EAFB" />
    <polygon points="0.0,-8.0 121.2,62.0 24.2,118.0 -97.0,48.0" fill="#FFFFFF" />
    <polygon points="88.3,65.0 83.1,68.0 83.1,-14.0 88.3,-17.0" fill="#BCD1F8" />
    <polygon points="29.4,37.0 83.1,68.0 83.1,-14.0 29.4,-45.0" fill="#E4EDFD" />
    <polygon points="34.6,-48.0 88.3,-17.0 83.1,-14.0 29.4,-45.0" fill="#FFFFFF" />
    <text transform="matrix(0.8660 0.5 0 1 35.5 -25.5)" className="lp-iso-doc" fill="#0B1B3F">
      {"NOTICE"}
    </text>
    <polygon points="35.5,-11.5 73.6,10.5 73.6,7.5 35.5,-14.5" fill="#BCD1F8" />
    <polygon points="35.5,-2.5 68.4,16.5 68.4,13.5 35.5,-5.5" fill="#BCD1F8" />
    <polygon points="35.5,6.5 73.6,28.5 73.6,25.5 35.5,3.5" fill="#BCD1F8" />
    <polygon points="35.5,15.5 61.5,30.5 61.5,27.5 35.5,12.5" fill="#BCD1F8" />
    <circle cx="0" cy="0" r="8" fill="#F2A33A" transform="matrix(0.8660 0.5 0 1 67.5 45.0)" />
    <circle cx="0" cy="0" r="5" fill="none" className="lp-iso-stamp" transform="matrix(0.8660 0.5 0 1 67.5 45.0)" />
    <polygon points="15.6,53.0 -22.5,75.0 -22.5,71.0 15.6,49.0" fill="#BCD1F8" />
    <polygon points="-71.0,47.0 -22.5,75.0 -22.5,71.0 -71.0,43.0" fill="#E4EDFD" />
    <polygon points="-32.9,21.0 15.6,49.0 -22.5,71.0 -71.0,43.0" fill="#FFFFFF" />
    <polygon points="-31.2,28.0 -28.1,29.8 -54.1,44.8 -57.2,43.0" fill="#2563DE" />
    <polygon points="-23.4,32.5 -20.4,34.2 -37.7,44.2 -40.7,42.5" fill="#BCD1F8" />
    <polygon points="-15.6,37.0 -12.6,38.8 -38.5,53.8 -41.6,52.0" fill="#BCD1F8" />
    <polygon points="-7.8,41.5 -4.8,43.2 -22.1,53.2 -25.1,51.5" fill="#BCD1F8" />
    <path d="M9.8 88.0 L9.8 62.0 L31.8 62.0 L31.8 88.0 A11.0 6.4 0 0 1 9.8 88.0 Z" fill="#0B1B3F" />
    <ellipse cx="20.8" cy="62.0" rx="11.0" ry="6.4" fill="#2A3D69" />
    <circle cx="20.8" cy="49.9" r="8.5" fill="#2A3D69" />
    <g className="lp-iso-bubble lp-float-a">
      <rect x="-68.6" y="-46.0" width="68" height="36" rx="12" fill="#FFFFFF" />
      <path d="M-54.6 -11.0 l-2 11 l12 -11 z" fill="#FFFFFF" />
      <text x="-34.6" y="-22.0" className="lp-iso-q" fill="#0B1B3F">
        {"“ … ”"}
      </text>
    </g>
    <g className="lp-iso-badge lp-float-b">
      <circle cx="90.3" cy="-21.0" r="15" fill="#F2A33A" />
      <circle cx="90.3" cy="-21.0" r="15" fill="none" className="lp-iso-badge-ring" />
      <path d="M84.0 -20.7 L88.8 -15.9 L97.1 -25.5" className="lp-iso-check" />
    </g>
    </svg>
  );
}
